import { render, staticRenderFns } from "./MemberService.vue?vue&type=template&id=645f85e5&scoped=true&"
var script = {}
import style0 from "./MemberService.vue?vue&type=style&index=0&id=645f85e5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645f85e5",
  null
  
)

export default component.exports